import React from 'react'
import {FaceOffTab} from './FaceOffTab/FaceOffTab'

// Tab id (from the registry in ../constants.ts) to the component it renders.
export const FACIAL_RECOGNITION_TAB_COMPONENTS: Record<string, React.FC> = {
  faceOff: FaceOffTab,
}
